import { Reducer } from 'redux';
import { ContactUsActionTypes, IContactUsState } from 'src/state/contactus/types';

export const initialState: IContactUsState = {
  failedToSend: undefined,
  isSending: undefined,
  isLoadingResources: undefined,
  sentSuccessfully: undefined,
  supportTicketResponse: undefined,
  supportTicketEmail: undefined,
  supportTicketFieldErrors: undefined,
  countryCodes: undefined,
  addHeroBarListener: false
};

const reducer: Reducer<IContactUsState> = (state = initialState, action) => {
  switch (action.type) {
    case ContactUsActionTypes.CONTACT_RESOURCES_REQUEST: {
      return { ...state, isLoadingResources: true };
    }
    case ContactUsActionTypes.CONTACT_RESOURCES_SUCCESS: {
      return {
        ...state,
        countryCodes: action.payload.countryCodes,
        isLoadingResources: false
      };
    }
    case ContactUsActionTypes.CONTACT_RESOURCES_ERROR: {
      return {
        ...state,
        isLoadingResources: false
      };
    }

    case ContactUsActionTypes.CONTACTUS_CREATESUPPORTTICKET: {
      return {
        ...state,
        isSending: true,
        failedToSend: false,
        sentSuccessfully: false,
        supportTicketResponse: undefined,
        supportTicketEmail: undefined,
        supportTicketFieldErrors: undefined
      };
    }
    case ContactUsActionTypes.CONTACTUS_CREATESUPPORTTICKET_ERROR: {
      return {
        ...state,
        isLoadingCountries: false,
        isLoadingCategories: false,
        failedToSend: true,
        isSending: false,
        supportTicketFieldErrors: action.payload?.fieldErrors
      };
    }
    case ContactUsActionTypes.CONTACTUS_CREATESUPPORTTICKET_SUCCESS: {
      return {
        ...state,
        supportTicketResponse: action.payload.supportTicketResponse,
        supportTicketEmail: action.payload.supportTicketEmail,
        supportTicketFieldErrors: undefined,
        isLoadingCountries: false,
        isLoadingCategories: false,
        failedToSend: false,
        isSending: false,
        sentSuccessfully: true
      };
    }
    case ContactUsActionTypes.SET_ADD_HERO_BAR_LISTENER: {
      return { ...state, addHeroBarListener: action.payload as boolean };
    }
    default: {
      return state;
    }
  }
};

export { reducer as contactUsReducer };

